import type { Metric } from '../types.tsx';
import messages from './messages.tsx';

export const ISSUE_KEY = 'issue';

export const ISSUE: Metric = {
	key: ISSUE_KEY,
	visible: true,
	name: messages.name,
	description: messages.description,
	tabLabels: [messages.reviewAndAnalyze, messages.activityLog],
	warningMessage: messages.warning,
	exceededMessage: messages.exceeded,
	risks: [messages.risk1],
	mitigations: [messages.mitigation1, messages.mitigation2, messages.mitigation3],
	currentValueLabel: messages.currentValueLabel,
	currentValueAriaLabel: messages.currentValueAriaLabel,
	thresholdValueLabel: messages.thresholdValueLabel,
	thresholdValueAriaLabel: messages.thresholdValueAriaLabel,
	graphHeader: messages.graphHeader,
};
